import { Component, OnInit } from '@angular/core';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
declare var $: any;


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent extends BaseClass<any> implements OnInit {

  constructor(
    public _common: CommonService,
    public _shared: SharedService,
    public service: WebserviceService,
    ) 
    { 
      super();
    }

  ngOnInit() {  
    //this.loadCssFile("assets/css/themes.css"); 
    this.loadJsFile("assets/js/app.js"); 
  }
  
  getServices(): IbaseService<any> {
    return this.service;
  }

  public loadJsFile(url:any) {  
    let node = document.createElement('script');  
    node.src = url;  
    node.type = 'text/javascript';  
    document.getElementsByTagName('head')[0].appendChild(node);  
  }

  // public loadCssFile(url:any) {  
  //   let node = document.createElement('link');  
  //   node.href = url;  
  //   node.type = 'text/css';  
  //   document.getElementsByTagName('head')[0].appendChild(node);  
  // }

  openLogin() {
    this._shared.emitLoginModal({ 'login': true });
  }

  openRightBar(){
    $('#rightsidebar').show();
    $('body').addClass("rightsidebar-open");
  }

}
